export function formatarCompetenciaBR(valor?: string | null) {
  const texto = String(valor || '').trim()
  const match = texto.match(/^(\d{4})-(\d{2})(?:-\d{2})?$/)
  if (!match) return texto || '—'
  return `${match[2]}/${match[1]}`
}
